<div #stackedBar id="stackedBar" class="line-chart"></div>